import {Component, OnInit} from '@angular/core';
import {ServiceStatusService} from '../../../services/service-status/service-status.service';
import {ServiceStatus} from '../../../models/service-status';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
  standalone: true,
  imports: []
})
export class MaintenanceComponent implements OnInit {
  public status: ServiceStatus | null = null;

  constructor(private serviceStatusService: ServiceStatusService) {}

  public ngOnInit(): void {
    this.serviceStatusService.getStatus().then(status => {
      this.status = status;
    });
  }
}
